import { useCallback } from "react";
import { useNavigate } from "react-router";

import { URLS } from "config/urls";
import { HistoryEduOutlinedIcon } from "icons";
import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

export interface IESignDocumentsButton {
  documentsCount: number;
}
const ESignDocumentsButton = ({ documentsCount }: IESignDocumentsButton) => {
  const navigate = useNavigate();

  const navigateToESignDocumentsPage = useCallback(
    () => navigate(URLS.E_SIGN_DOCUMENTS),
    [navigate]
  );

  return (
    <Tooltip title="E-sign documents" enterDelay={500}>
      <Stack sx={{ cursor: "pointer", position: "relative" }}>
        {documentsCount > 0 && (
          <Stack
            sx={{
              width: "20px",
              height: "15px",
              position: "absolute",
              right: "-8px",
              top: "-4px",
              borderRadius: "20px",
              backgroundColor: colors.blue100,
              justifyContent: "center",
              alignItems: "center",
              paddingLeft: "2px",
              zIndex: 2,
            }}
          >
            <Text
              color={colors.white}
              fontSize={12}
              fontWeight={700}
              data-testid="notifications-count"
            >
              {documentsCount}
            </Text>
          </Stack>
        )}
        <HistoryEduOutlinedIcon
          onClick={navigateToESignDocumentsPage}
          sx={{
            cursor: "pointer",
            color: colors.gray5,
            fontSize: "24px",
            transition: "opacity 0.2s ease-in-out",
            opacity: 0.6,
            "&:hover": { opacity: 1 },
          }}
        />
      </Stack>
    </Tooltip>
  );
};

export default ESignDocumentsButton;
